<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar flat color="#008dd4" dark>
                <v-btn icon @click="$parent.show_dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Mostrar Alumno</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                       <v-btn class="mr-6" fab small color="error" v-bind="attrs" v-on="on">
                            <v-icon>mdi-file-pdf</v-icon>
                        </v-btn>
                    </template>
                    <span>Exportar</span>
                </v-tooltip>

            </v-toolbar>
            <v-container>
                <v-row>
                    <v-col cols="12" lg="6" md="10" class="mx-auto">
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th>Clave</th>
                                        <th>Valor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>ID</td>
                                        <td>{{ item.id }}</td>
                                    </tr>
                                    <tr>
                                        <td>Folio</td>
                                        <td>{{ item.folio }}</td>
                                    </tr>
                                    <tr>
                                        <td>Nombre de usuario</td>
                                        <td>{{ item.name }}</td>
                                    </tr>
                                    <tr>
                                        <td>Correo electrónico</td>
                                        <td>{{ item.email }}</td>
                                    </tr>
                                    <tr>
                                        <td>Nombre(s)</td>
                                        <td>{{ item.names }}</td>
                                    </tr>
                                    <tr>
                                        <td>Apellido paterno</td>
                                        <td>{{ item.paternal_surname }}</td>
                                    </tr>
                                    <tr>
                                        <td>Apellido materno</td>
                                        <td>{{ item.maternal_surname }}</td>
                                    </tr>
                                    <tr>
                                        <td>Teléfono</td>
                                        <td>{{ item.phone }}</td>
                                    </tr>
                                    <tr>
                                        <td>Autorizado</td>
                                        <td>{{ item.authorized ? 'Autorizado' : 'No autorizado' }}</td>
                                    </tr>
                                    <tr>
                                        <td>Estatus</td>
                                        <td>{{ item.status ? 'Habilitado' : 'Deshabilitado' }}</td>
                                    </tr>
                                    <tr>
                                        <td>Fecha de registro</td>
                                        <td>{{ item.created_at }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props:['dialog', 'item'],
    data: () => ({

    }),

    methods:{

    }
}
</script>
